/**
 * New Store v2 Template
 *
 * Rules
 * ====================================
 * 1. In the ./modules directory there should only be 1 store file per Tab, or a
 *    folder per Tab if you need to break large stores down further.
 *
 */

const state = {
  pages: []
}

const getters = {
  pages(state) {
    return state.pages
  }
}

// Mutations must be synchronous...
const mutations = {
  setPages(state, payload) {
    state.pages = payload
  }
}

// Actions can be asynchronous...
const actions = {
  setPages(context, payload) {
    context.commit('setPages', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
